export const Ornament = ({ className = "", color = "#b8893b" }) => (
  <svg viewBox="0 0 240 20" className={className} fill="none" aria-hidden="true">
    <line x1="0" y1="10" x2="96" y2="10" stroke={color} strokeWidth="0.8" />
    <line x1="144" y1="10" x2="240" y2="10" stroke={color} strokeWidth="0.8" />
    <path d="M120 3 L126 10 L120 17 L114 10 Z" stroke={color} strokeWidth="0.9" />
    <path d="M113 10c-4-6-10-6-12 0 2 5 8 5 9 1M127 10c4-6 10-6 12 0-2 5-8 5-9 1" stroke={color} strokeWidth="0.8" />
    <circle cx="120" cy="10" r="1.4" fill={color} />
  </svg>
);

export const LogoMark = ({ className = "" }) => (
  <img src="/media/logo-mark.png" alt="Dari Event" className={`select-none object-contain ${className}`} draggable="false" />
);

export const Logo = ({ dark = false, className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-9 w-9" />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-[1.55rem] font-medium tracking-tight ${dark ? "text-[#f6ecd9]" : "text-[#3d2a14]"}`}>Dari event</span>
      <Ornament className="mt-0.5 h-2 w-full" color={dark ? "#e6ca7a" : "#b8893b"} />
    </span>
  </span>
);
